import React from 'react';
import { useSelector } from 'react-redux';

import selectors from 'state/selectors';
import utils from 'utils';

import Header from 'components/Modal/Header';
import Modal from 'components/Modal';

const DeleteConfirmationModal = () => {
  const t = utils.intl.useTranslator();
  const modalProps = useSelector(selectors.modal.getModalProps);

  return (
    <>
      <Header title={modalProps.title ?? t('delete_confirmation')} subtitle={modalProps.subtitle} />
      <Modal.Footer
        confirmAction={modalProps.func}
        confirmText={t('continua')}
        closeButtonText={t('annulla')}
      />
    </>
  );
};

export default DeleteConfirmationModal;
